import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import MapPropTypes from '../../MapPropTypes';
import strings from '../../../strings';
import './ContactForm.scss';

class ContactForm extends Component {
    static propTypes = {
        contacts: PropTypes.arrayOf(MapPropTypes.ContactProps).isRequired,
        updateSubjectIndex: PropTypes.func.isRequired,
        updateMessage: PropTypes.func.isRequired,
        sendMessage: PropTypes.func.isRequired,
        subjectIndex: PropTypes.number.isRequired,
        message: PropTypes.string.isRequired,
        messageInTransit: PropTypes.bool.isRequired,
        messageSent: PropTypes.bool.isRequired,
    };

    _handleMessageChange(evt) {
        this.props.updateMessage(evt.target.value);
    }

    _handleSubjectChange(evt) {
        this.props.updateSubjectIndex(parseInt(evt.target.value, 10));
    }

    _handleSendClick() {
        this.props.sendMessage();
    }

    render() {
        const {
            message,
            messageInTransit,
            contacts,
            subjectIndex,
            messageSent,
        } = this.props;
        const label = messageSent ? (
            <div className="disappearing-label">
                <CSSTransition
                    classNames="animate"
                    timeout={5000}
                    appear={true}
                    in={true}
                >
                    <span>{strings.messageSent}</span>
                </CSSTransition>
            </div>
        ) : null;

        return (
            <form className="contact-form p-a-md">
                <fieldset className="form-group">
                    <label htmlFor="subject">
                        <strong>{strings.subject}</strong>
                    </label>
                    <select
                        className="form-control"
                        id="subject"
                        value={subjectIndex}
                        onChange={(evt) => this._handleSubjectChange(evt)}
                        disabled={messageInTransit}
                    >
                        {contacts.map((contact, i) => (
                            <option key={i} value={i}>
                                {contact.kind}
                            </option>
                        ))}
                    </select>
                </fieldset>
                <fieldset className="form-group">
                    <label htmlFor="emailText">
                        <strong>{strings.message}</strong>
                    </label>
                    <textarea
                        className="form-control"
                        id="emailText"
                        value={message}
                        onChange={(evt) => this._handleMessageChange(evt)}
                        disabled={messageInTransit}
                    />
                </fieldset>
                <fieldset className="form-group m-b-0">
                    <div className="col-md-8 p-l-0 text-muted">{label}</div>
                    <div className="col-md-4 text-right p-r-0">
                        <button
                            className="btn btn-success"
                            type="button"
                            onClick={() => this._handleSendClick()}
                            disabled={message === '' || messageInTransit}
                        >
                            {strings.sendMessage}
                        </button>
                    </div>
                </fieldset>
            </form>
        );
    }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./app/components/Modals/HelpModal/ContactForm.jsx